import React from "react";
import { RequireRole } from "@/lib/useUser";

export const RequireStaff: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <RequireRole allowed={["staff", "admin"]} fallback={<div className="p-6 text-white">Access denied</div>}>
    {children}
  </RequireRole>
);
